import React from 'react';
import { Box, Typography } from '@mui/material';
import PhotoPreview from '../../../components/PhotoPreview';

interface PhotoUploadSectionProps {
  previewUrls: string[];
  onPhotoUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function PhotoUploadSection({
  previewUrls,
  onPhotoUpload,
}: PhotoUploadSectionProps) {
  return (
    <>
      <Box mb={2} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
        <Typography variant="body2">
          Upload photos for AdSpace
        </Typography>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={onPhotoUpload}
          style={{ margin: 0 }}
        />
      </Box>
      <Box sx={{ mt: 2 }}>
        <PhotoPreview previewUrls={previewUrls} />
      </Box>
    </>
  );
}

